/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number → Roman`)
};

const es_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número → Romano`)
};

const de_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahl → Römisch`)
};

const nl_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getal → Romeins`)
};

const fr_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre → Romain`)
};

const it_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero → Romano`)
};

const pt_br2_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número → Romano`)
};

const pt_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número → Romano`)
};

const ja_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字 → ローマ数字`)
};

const zh_rn_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number → Roman`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_mode_encode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_mode_encode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_mode_encode", locale)
	if (locale === "en") return en_rn_mode_encode(inputs)
	if (locale === "es") return es_rn_mode_encode(inputs)
	if (locale === "de") return de_rn_mode_encode(inputs)
	if (locale === "nl") return nl_rn_mode_encode(inputs)
	if (locale === "fr") return fr_rn_mode_encode(inputs)
	if (locale === "it") return it_rn_mode_encode(inputs)
	if (locale === "pt-BR") return pt_br2_rn_mode_encode(inputs)
	if (locale === "pt") return pt_rn_mode_encode(inputs)
	if (locale === "ja") return ja_rn_mode_encode(inputs)
	return zh_rn_mode_encode(inputs)
};